import store from '../store/store'
import axios from '../axios'

export default class SupportCaseService {

  getSupportCase(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/usersupportcase/' + id;
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateSupportCase(supportCase) {
    if (supportCase.id) {
      return new Promise(async function(resolve, reject) {
        try {
          var path = '/v1/usersupportcase/' + supportCase.id
          
          var response = await axios.put(path, supportCase)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      })
    } else {
      
    }
  }

  saveSupportCase(supportCase) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/usersupportcase/'
        
        var response = await axios.post(path, supportCase)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllSupportCases() {
    return new Promise(async (resolve, reject) => {

        try {
          var path = '/v1/userSupportCases'
          
          var response = await axios.get(path)          
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
    })
  }


}